import React from "react";
import { cn } from "@/utils/cn";
import { DynamicPopover, DynamicPopoverProps } from "./dynamic-popover";
import { IconButton } from "./icon-button";

interface MoreActionPopoverProps extends Omit<DynamicPopoverProps, 'trigger' | 'children'> {
  tiggerIcon: React.ReactNode;
  tiggerClassName?: string;
  children: React.ReactElement<MoreAcrionItemProps> | React.ReactElement<MoreAcrionItemProps>[];
}

interface MoreAcrionItemProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: React.ReactNode;
  label: string;
}

export const MoreActionItem = React.forwardRef<HTMLButtonElement, MoreAcrionItemProps>(
  ({ icon, label, className, ...buttonProps }, ref) => {
    return (
      <button
        ref={ref}
        className={cn(
          "flex w-full items-center gap-2 rounded-sm px-3 h-10 text-sm text-[rgba(52,64,84,1)] transition-colors",
          "hover:bg-[rgba(249,250,251,1)]",
          "focus:bg-[rgba(249,250,251,1)] focus:outline-none",
          "disabled:pointer-events-none disabled:opacity-50",
          className
        )}
        {...buttonProps}
      >
        <span className="flex-shrink-0">
          {icon}
        </span>
        <span className="flex-1 text-left">{label}</span>
      </button>
    );
  }
);

export const MoreActionPopover = ({
  tiggerIcon,
  tiggerClassName,
  children,
  ...popoverProps
}: MoreActionPopoverProps) => {
  return (
    <DynamicPopover
      {...popoverProps}
      className={`space-y-1 ${popoverProps.className}`}
      trigger={
        <IconButton
          icon={tiggerIcon}
          className={tiggerClassName}
          onClick={(e) => {
            e.stopPropagation();
          }}
        />
      }
    >
      {children}
    </DynamicPopover>
  );
};
